export default "__VITE_ASSET__JWrQpoTH__"